// fix_issue3.md #3 - a compact star display, and (when onRate is given) a clickable star input.
export default function StarRating({ value = 0, count, onRate, size = '1rem' }) {
  const rounded = Math.round(value * 2) / 2;
  const stars = [1, 2, 3, 4, 5].map((n) => {
    const filled = onRate ? n <= value : n <= rounded;
    const half = !onRate && !filled && n - 0.5 === rounded;
    const glyph = filled ? '★' : half ? '⯨' : '☆';
    if (onRate) {
      return (
        <button
          key={n}
          type="button"
          onClick={() => onRate(n)}
          className="btn btn-link p-0 text-warning"
          style={{ fontSize: size, lineHeight: 1, textDecoration: 'none' }}
          aria-label={`Rate ${n} star${n > 1 ? 's' : ''}`}
        >
          {glyph}
        </button>
      );
    }
    return (
      <span key={n} className="text-warning" style={{ fontSize: size, lineHeight: 1 }}>
        {glyph}
      </span>
    );
  });

  return (
    <span className="d-inline-flex align-items-center gap-1">
      <span className="d-inline-flex">{stars}</span>
      {!onRate && (
        <span className="small text-muted">
          {value > 0 ? value.toFixed(1) : 'No ratings yet'}
          {count != null && value > 0 ? ` (${count})` : ''}
        </span>
      )}
    </span>
  );
}
